import { coreAxios } from "@/declare/api/axios"
import { AxiosResponse } from "axios";
import qs from "qs";

/**
 * 创建块
 * @param data 块的json
 * @param params 
 * @returns 
 */
export function createBlock(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/blocks`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 编辑块
 * @param blockUuid 
 * @param data 
 * @param params 
 * @returns 
 */
export function updateBlock(blockUuid: string, data: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/blocks/${blockUuid}`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取详细的块模板
 * @param blockUuid 
 * @param params 
 * @returns 
 */
export function findBlock(blockUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/blocks/${blockUuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 查找项目中的所有块模板列表
 * @param projectUuid 
 * @param params 
 * @returns 
 */
export function findBlocksInProject(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/blocks`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 删除块
 * @param uuid 
 * @param params 
 * @returns 
 */
export function deleteBlockInGraphic(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/blocks/${uuid}`, {
        params: {
            ...params,
        }
    })
}

// 批量删除
export function deleteBlockMulti(uuids: string[]): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/blocks/multi-delete`, uuids, {
        params: {
        }
    })
}